import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { useLanguage } from '../components/Navbar';
import SEO from '../components/SEO';

const PageSection = styled.section`
  padding: 120px 0 80px;
`;

const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 60px;
`;

const PageTitle = styled(motion.h1)`
  font-size: 3.5rem;
  font-weight: 800;
  margin-bottom: 1.5rem;
  position: relative;
  display: inline-block;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 4px;
    background-color: #ff0000;
  }
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const PageSubtitle = styled(motion.p)`
  font-size: 1.2rem;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
  color: #666;
`;

const Events: React.FC = () => {
  const { language } = useLanguage();
  
  // SEO metadata for Events page
  const eventsSeoData = {
    en: {
      title: 'Events - Barkin Sayin | Speaking Engagements & Conferences',
      description: 'View upcoming and past events featuring Barkin Sayin, including speaking engagements, conferences, and workshops on fintech, smart TV technology, and entrepreneurship.',
      keywords: [
        'Barkin Sayin events',
        'fintech conferences',
        'speaking engagements',
        'technology workshops',
        'entrepreneur events',
        'smart TV seminars',
        'digital transformation talks'
      ]
    },
    tr: {
      title: 'Etkinlikler - Barkın Sayın | Konuşmalar ve Konferanslar',
      description: 'Barkın Sayın\'ın fintech, akıllı TV teknolojisi ve girişimcilik konularındaki konuşmaları, konferansları ve çalıştayları dahil olmak üzere gelecek ve geçmiş etkinlikleri görüntüleyin.',
      keywords: [
        'Barkın Sayın etkinlikler',
        'fintech konferansları',
        'konuşma etkinlikleri',
        'teknoloji çalıştayları',
        'girişimci etkinlikleri',
        'akıllı TV seminerleri',
        'dijital dönüşüm konuşmaları'
      ]
    }
  };
  
  const seoTitle = eventsSeoData[language as keyof typeof eventsSeoData]?.title || eventsSeoData.en.title;
  const seoDescription = eventsSeoData[language as keyof typeof eventsSeoData]?.description || eventsSeoData.en.description;
  const seoKeywords = eventsSeoData[language as keyof typeof eventsSeoData]?.keywords || eventsSeoData.en.keywords;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <SEO 
        title={seoTitle}
        description={seoDescription}
        keywords={seoKeywords}
      />
      
      <PageSection>
        <PageContainer>
          <PageHeader>
            <PageTitle
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Events & Speaking
            </PageTitle>
            
            <PageSubtitle
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Upcoming and past events, conferences, and speaking engagements featuring Barkın Sayın.
            </PageSubtitle>
          </PageHeader>
          
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <p style={{ textAlign: 'center' }}>Events content coming soon.</p>
          </motion.div>
        </PageContainer>
      </PageSection>
    </motion.div>
  );
};

export default Events; 